"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetingLocation = void 0;
class TargetingLocation {
    locationName;
    locationId;
    type;
    googleLocationId;
}
exports.TargetingLocation = TargetingLocation;
//# sourceMappingURL=TargetingLocation.js.map